import { Dispatch } from 'react';
import {
  FlatFileObjectConfigFormReducerAction,
  FlatFileObjectConfigFormReducerActionType
} from './interfaces';

export interface FlatFileObjectConfigFormReducerActions {
  initInferSchema: VoidFunction;
  saveInferSchemaError: (error: string) => void;
  saveInferSchemaSuccess: (objectId: string) => void;
  saveInferSchemaTaskId: (taskId: string) => void;
}

export function FlatFileObjectConfigFormReducerActionsFactory(
  dispatch: Dispatch<FlatFileObjectConfigFormReducerAction>
): FlatFileObjectConfigFormReducerActions {
  return {
    initInferSchema: () =>
      dispatch({ type: FlatFileObjectConfigFormReducerActionType.INIT_INFER_SCHEMA }),
    saveInferSchemaError: (error: string) =>
      dispatch({
        type: FlatFileObjectConfigFormReducerActionType.SAVE_INFER_SCHEMA_ERROR,
        data: { inferSchemaError: error }
      }),
    saveInferSchemaSuccess: (objectId: string) =>
      dispatch({
        type: FlatFileObjectConfigFormReducerActionType.SAVE_INFER_SCHEMA_SUCCESS,
        data: {
          objectId
        }
      }),
    saveInferSchemaTaskId: (taskId: string) =>
      dispatch({
        type: FlatFileObjectConfigFormReducerActionType.SAVE_INFER_SCHEMA_TASK_ID,
        data: {
          inferSchemaTaskId: taskId
        }
      })
  };
}
